// A map of causes leading to changes in components

const ENTER_PRESS = 'ENTER_PRESS';
const SUGGESTION_SELECT = 'SUGGESTION_SELECT';
const CLEAR_VALUE = 'CLEAR_VALUE';
const SEARCH_ICON_CLICK = 'SEARCH_ICON_CLICK';

const causes = {
  ENTER_PRESS,
  SUGGESTION_SELECT,
  CLEAR_VALUE,
  SEARCH_ICON_CLICK
};

export default causes;
